import { AddressSearchUtil } from 'utilities/address';
import visit from 'utilities/visit';
type urlOptions = {
  search?: string|any
}
export default class Location {
  visit(urlOrOptions: string | urlOptions){
    if(typeof(urlOrOptions) === 'string'){
      this.visitURL(urlOrOptions)
    }else{
      if(urlOrOptions.search){
        let url = this.changeSearch(urlOrOptions.search);
        this.visitURL(url);
      }
    }
  }

  private visitURL(url: string){
    visit(url);
  }
  private changeSearch(search: string | any): string{
    if(typeof(search) !== 'string'){
      search = AddressSearchUtil.mergeAndStringify(search);
    }
    let url = ''
    if(window.location.search.length >= 1){
      url = window.location.href.replace(window.location.search, '?' + search);
    } else {
      url = window.location.href + '?' + search;
    }
    return url;
  }

  private blank(url: string){
    window.open(url, '_blank');
  }

  refresh(url: string){
    window.location.href = url;
  }
}
